import React, { useState } from "react";
import { CardBody } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import styles from "../../styles.scss";
import SocialMediaInput from "../../common/socialMediaInput";
import { faFacebook, faInstagram, faLinkedin, faPinterest, faTiktok, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";

const EmailSocialsSection = () => {
  const [facebookEnabled, setFacebookEnabled] = useState(true);
  const [facebook, setFacebook] = useState("https://");

  const [twitterEnabled, setTwitterEnabled] = useState(true);
  const [twitter, setTwitter] = useState("https://");

  const [pinterestEnabled, setPinterestEnabled] = useState(true);
  const [pinterest, setPinterest] = useState("https://");

  const [youtubeEnabled, setYoutubeEnabled] = useState(true);
  const [youtube, setYoutube] = useState("https://");

  const [linkedinEnabled, setLinkedinEnabled] = useState(true);
  const [linkedin, setLinkedin] = useState("https://");

  const [instagramEnabled, setInstagramEnabled] = useState(true);
  const [instagram, setInstagram] = useState("https://");

  const [tiktokEnabled, setTiktokEnabled] = useState(true);
  const [tiktok, setTiktok] = useState("https://");

  return (
    <CardBody>
      <div className={styles.section}>
        <SocialMediaInput
          isEnabled={facebookEnabled}
          setIsEnabled={setFacebookEnabled}
          label="Facebook"
          value={facebook || ""}
          setValue={setFacebook}
          icon={faFacebook}
        />
        <SocialMediaInput
          isEnabled={twitterEnabled}
          setIsEnabled={setTwitterEnabled}
          label="Twitter"
          value={twitter || ""}
          setValue={setTwitter}
          icon={faTwitter}
        />
        <SocialMediaInput
          isEnabled={pinterestEnabled}
          setIsEnabled={setPinterestEnabled}
          label="Pinterest"
          value={pinterest || ""}
          setValue={setPinterest}
          icon={faPinterest}
        />
        <SocialMediaInput
          isEnabled={youtubeEnabled}
          setIsEnabled={setYoutubeEnabled}
          label="YouTube"
          value={youtube || ""}
          setValue={setYoutube}
          icon={faYoutube}
        />
        <SocialMediaInput
          isEnabled={linkedinEnabled}
          setIsEnabled={setLinkedinEnabled}
          label="LinkedIn"
          value={linkedin || ""}
          setValue={setLinkedin}
          icon={faLinkedin}
        />
        <SocialMediaInput
          isEnabled={instagramEnabled}
          setIsEnabled={setInstagramEnabled}
          label="Instagram"
          value={instagram || ""}
          setValue={setInstagram}
          icon={faInstagram}
        />
        <SocialMediaInput
          isEnabled={tiktokEnabled}
          setIsEnabled={setTiktokEnabled}
          label="TikTok"
          value={tiktok || ""}
          setValue={setTiktok}
          icon={faTiktok}
        />
      </div>
    </CardBody>
  );
};

export default withStyles(styles)(EmailSocialsSection);
